import { Search, Filter, X } from "lucide-react";
import useQuoteStatuses from "../../hooks/useQuoteStatuses";

function FilterField({ label, children }) {
  return (
    <div>
      <div className="label-tech text-[10px] mb-1">{label}</div>
      {children}
    </div>
  );
}

export default function QuoteFilters({ t, filters, setFilters, customers, showFilters, setShowFilters, resetFilters, activeCount }) {
  const apiStatuses = useQuoteStatuses();
  const STATUS_OPTIONS = [
    { v: "all", label: t("dashboard.filterAllStatuses") },
    ...apiStatuses.map((s) => ({ v: s.id, label: t(`status.${s.id}`, { defaultValue: s.label_it }) })),
  ];

  return (
    <>
      <div className="mb-4 flex items-center gap-2 flex-wrap" data-testid="dashboard-filters">
        <div className="flex-1 min-w-[200px] relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none"/>
          <input
            type="text"
            value={filters.q}
            onChange={(e) => setFilters({ ...filters, q: e.target.value })}
            placeholder={t("dashboard.searchPlaceholder")}
            className="w-full pl-9 pr-3 py-2 rounded-md bg-slate-900 border border-slate-700 text-sm text-slate-100"
            data-testid="filter-search"
          />
        </div>
        <button onClick={() => setShowFilters((s) => !s)} className={`px-3 py-2 rounded-md text-sm border flex items-center gap-2 ${showFilters ? "bg-blue-500/10 text-blue-300 border-blue-500/50" : "bg-slate-900 text-slate-300 border-slate-700 hover:border-slate-500"}`} data-testid="filter-toggle">
          <Filter size={14}/> {t("dashboard.filters")} {activeCount > 0 && <span className="ml-1 px-1.5 py-0.5 rounded-full bg-blue-500 text-white text-[10px] font-bold">{activeCount}</span>}
        </button>
        {activeCount > 0 && (
          <button onClick={resetFilters} className="px-3 py-2 rounded-md text-sm text-slate-400 hover:text-slate-100 flex items-center gap-1" data-testid="filter-reset">
            <X size={14}/> {t("dashboard.filtersReset")}
          </button>
        )}
      </div>

      {showFilters && (
        <div className="mb-5 p-4 rounded-md bg-slate-900 border border-slate-800 grid grid-cols-1 md:grid-cols-4 gap-3" data-testid="filters-panel">
          <FilterField label={t("dashboard.filterStatus")}>
            <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm" data-testid="filter-status">
              {STATUS_OPTIONS.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
            </select>
          </FilterField>
          <FilterField label={t("dashboard.filterCustomer")}>
            <select value={filters.customer_id} onChange={(e) => setFilters({ ...filters, customer_id: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm" data-testid="filter-customer">
              <option value="all">{t("dashboard.filterAllCustomers")}</option>
              <option value="none">{t("dashboard.filterNoCustomer")}</option>
              {customers.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </FilterField>
          <FilterField label={t("dashboard.filterFrom")}>
            <input type="date" value={filters.date_from} onChange={(e) => setFilters({ ...filters, date_from: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm font-mono-data" data-testid="filter-date-from"/>
          </FilterField>
          <FilterField label={t("dashboard.filterTo")}>
            <input type="date" value={filters.date_to} onChange={(e) => setFilters({ ...filters, date_to: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm font-mono-data" data-testid="filter-date-to"/>
          </FilterField>
          <FilterField label={t("dashboard.filterSource")}>
            <select value={filters.source} onChange={(e) => setFilters({ ...filters, source: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm" data-testid="filter-source">
              <option value="all">{t("dashboard.sourceAll")}</option>
              <option value="drawing">{t("dashboard.sourceDrawing")}</option>
              <option value="time_study_pdf">{t("dashboard.sourceTimeStudy")}</option>
            </select>
          </FilterField>
          <FilterField label={t("dashboard.filterLanguage")}>
            <select value={filters.detected_language} onChange={(e) => setFilters({ ...filters, detected_language: e.target.value })} className="w-full px-2 py-1.5 rounded text-sm" data-testid="filter-language">
              <option value="all">{t("dashboard.languageAll")}</option>
              <option value="it">🇮🇹 Italiano</option>
              <option value="en">🇬🇧 English</option>
              <option value="de">🇩🇪 Deutsch</option>
              <option value="fr">🇫🇷 Français</option>
              <option value="es">🇪🇸 Español</option>
              <option value="pl">🇵🇱 Polski</option>
              <option value="other">🌍 {t("dashboard.languageOther")}</option>
              <option value="none">— {t("dashboard.languageNotDetected")}</option>
            </select>
          </FilterField>
        </div>
      )}
    </>
  );
}
